package com.hyperether.goodjob.scenes.contacts.site

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalFocusManager
import androidx.navigation.NavHostController
import com.hyperether.goodjob.addItemMargin
import com.hyperether.goodjob.map.MapComponent
import com.hyperether.goodjob.models.AddressObject
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.navigation.ContactDetails
import com.hyperether.goodjob.repository.remote.model.LatLng
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.about_site
import com.hyperether.goodjob.resources.add_new_site
import com.hyperether.goodjob.resources.address_mandatory
import com.hyperether.goodjob.resources.address_required
import com.hyperether.goodjob.resources.contact_name
import com.hyperether.goodjob.resources.delete_site
import com.hyperether.goodjob.resources.email_address
import com.hyperether.goodjob.resources.email_send_icon_24
import com.hyperether.goodjob.resources.enter_contact_name
import com.hyperether.goodjob.resources.enter_email_address
import com.hyperether.goodjob.resources.enter_site_name
import com.hyperether.goodjob.resources.ic_user
import com.hyperether.goodjob.resources.location_plus
import com.hyperether.goodjob.resources.phone
import com.hyperether.goodjob.resources.phone_24
import com.hyperether.goodjob.resources.save_changes
import com.hyperether.goodjob.resources.save_new_site
import com.hyperether.goodjob.resources.site_name_mandatory
import com.hyperether.goodjob.resources.site_name_required
import com.hyperether.goodjob.resources.site_updated
import com.hyperether.goodjob.resources.update_site
import com.hyperether.goodjob.scenes.addNew.AddNewHeader
import com.hyperether.goodjob.scenes.addNew.CustomNumberInputRowUser
import com.hyperether.goodjob.scenes.components.AddCustomInputRow
import com.hyperether.goodjob.scenes.components.AddressInputFieldWeb
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.contacts.ContactsViewModel
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.util.Constants
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.resources.stringResource

@Composable
fun AddNewSiteWeb(
    viewModel: ContactsViewModel,
    navHostController: NavHostController,
    contactId: String,
    siteId: String
) {
    val focusManager = LocalFocusManager.current

    LaunchedEffect(siteId) {
        viewModel.fetchSiteById(siteId)
        viewModel.fetchContactById(contactId)
    }
    LaunchedEffect(true) {
        println("CONTACT_ID:$contactId SITE_ID:$siteId")
    }
    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(DashboardBg)
            .verticalScroll(rememberScrollState())
            .disableMouseDragScrollOnWeb()
            .padding(bottom = addItemMargin())
    ) {
        val title = if (siteId == Constants.DEFAULT_SITE_ID || siteId.isEmpty()) {
            stringResource(Res.string.add_new_site)
        } else {
            stringResource(Res.string.update_site)
        }
        WebViewHeader(
            isAddNewJob = false,
            isBackAvailable = true,
            onBackClick = {
                navHostController.navigate(ContactDetails(contactId))
                viewModel.clearSiteValues()
            },
            title = title,
            isImportAndAddVisible = false,
            navHostController = navHostController
        )

        AddNewHeader(
            titleText = stringResource(Res.string.about_site),
            showDelete = siteId.isNotEmpty(),
            deleteText = stringResource(Res.string.delete_site),
            onDelete = {
                viewModel.showLoader.value = true
                viewModel.deleteSite(siteId, onSuccess = {
                    viewModel.showLoader.value = false
                    viewModel.showPopUpSuccessDeleted.value = true
                }, onError = {
                    viewModel.showLoader.value = false
                    viewModel.showPopUpError.value = true
                })
            }
        ) {
            Column(
                modifier = Modifier.fillMaxWidth().fillMaxHeight()
            ) {
                //form | map
                Row(
                    modifier = Modifier.fillMaxWidth().fillMaxHeight()
                ) {
                    // AddCustomInputRow is 56dp height with 10dp spacing, so total 5*56 + 4*10 = 320dp for map
                    //form
                    Column(
                        modifier = Modifier.weight(1f).fillMaxHeight(),
                        verticalArrangement = Arrangement.spacedBy(10.toScaleDp())
                    ) {
                        AddCustomInputRow(
                            painterResource = Res.drawable.location_plus,
                            labelText = stringResource(Res.string.site_name_mandatory),
                            placeholderText = stringResource(Res.string.enter_site_name),
                            inputValue = viewModel.siteNameInput.value,
                            onValueChange = { viewModel.siteNameInput.value = it },
                            focusManager = focusManager
                        )
                        AddCustomInputRow(
                            painterResource = Res.drawable.ic_user,
                            labelText = stringResource(Res.string.contact_name),
                            placeholderText = stringResource(Res.string.enter_contact_name),
                            inputValue = viewModel.siteContactNameInput.value,
                            onValueChange = { viewModel.siteContactNameInput.value = it },
                            focusManager = focusManager
                        )
                        AddCustomInputRow(
                            painterResource = Res.drawable.email_send_icon_24,
                            labelText = stringResource(Res.string.email_address),
                            placeholderText = stringResource(Res.string.enter_email_address),
                            inputValue = viewModel.siteEmailInput.value,
                            onValueChange = { viewModel.siteEmailInput.value = it },
                            focusManager = focusManager
                        )
                        AddressInputFieldWeb(
                            textCountry = mutableStateOf(""),
                            textCity = mutableStateOf(""),
                            text = viewModel.siteAddressInput,
                            label = stringResource(Res.string.address_mandatory),
                            onSearch = { viewModel.findPlace(it) },
                            onSelect = {
                                viewModel.siteAddressInput.value = it.formattedAddress
                                viewModel.place.value = it
                            },
                            places = viewModel.places,
                            focusManager = focusManager,
                            modifier = Modifier
                        )
                        CustomNumberInputRowUser(
                            painterResource = Res.drawable.phone_24,
                            labelText = stringResource(Res.string.phone),
                            placeholderText = "+1 555 123 4567",
                            inputValue = viewModel.sitePhoneInput.value,
                            onValueChange = { viewModel.sitePhoneInput.value = it },
                            focusManager = focusManager
                        )
                    }

                    Spacer(modifier = Modifier.width(20.toScaleDp()))

                    //map
                    Column(
                        modifier = Modifier
                            .weight(0.6f)
                            .height(320.toScaleDp())
                            .fillMaxWidth()
//                            .fillMaxHeight()
                    ) {
                        val currentPosition = mutableStateOf<LatLng?>(null)
                        viewModel.place.value?.let {
                            currentPosition.value =
                                LatLng(it.location.latitude, it.location.longitude)
                            //TODO maybe we should make marker here because when you are making new site viewModel.getRemoteSiteMarkers() returns empty list
                        }
                        MapComponent(
                            showMap = true,
                            showMapWeb = mutableStateOf(true),
                            markers = viewModel.getRemoteSiteMarkers(),
                            currentPosition = currentPosition
                        )
                    }
                }

                //submit
                Column(modifier = Modifier.fillMaxWidth()) {
                    val newSite = Site(
                        siteName = viewModel.siteNameInput.value,
                        parentName = viewModel.contact.value?.name,
                        parentId = contactId,
                        addressObject = AddressObject(
                            address = viewModel.siteAddressInput.value,
                            lat = viewModel.place.value?.location?.latitude,
                            long = viewModel.place.value?.location?.longitude
                        ),
                        personName = viewModel.siteContactNameInput.value,
                        personPhone = viewModel.sitePhoneInput.value,
                        personEmail = viewModel.siteEmailInput.value,
                        workspaceId = viewModel.repository.getWorkspaceId()
                    )
                    val textSiteUpdated = stringResource(Res.string.site_updated)
                    val siteNameRequired = stringResource(Res.string.site_name_required)
                    val addressRequiredError = stringResource(Res.string.address_required)
                    Spacer(modifier = Modifier.height(15.toScaleDp()))
                    Row(modifier = Modifier.fillMaxWidth()) {
                        FilledButton(
                            onClick = {
                                // Validate inputs before proceeding
                                val errorMessage = when {
                                    viewModel.siteNameInput.value.isBlank() -> siteNameRequired
                                    viewModel.siteAddressInput.value.isBlank() -> addressRequiredError
                                    else -> null
                                }
                                if (errorMessage != null) {
                                    viewModel.showPopUpError.value = true
                                    viewModel.errorText.value = errorMessage
                                } else {
                                    viewModel.showLoader.value = true
                                    if (siteId.isEmpty()) {
                                        viewModel.addSite(newSite)
                                    } else {
                                        viewModel.updateSite(
                                            siteId, newSite,
                                            onSuccess = {
                                                viewModel.showLoader.value = false
                                                viewModel.showPopUpSuccess.value = true
                                                viewModel.successApiText.value = textSiteUpdated
                                            },
                                            onError = {
                                                viewModel.showLoader.value = false
                                                viewModel.showPopUpError.value = true

                                            })
                                    }
                                }
                            },
                            text = if (siteId.isNotEmpty()) {
                                stringResource(Res.string.save_changes)
                            } else {
                                stringResource(Res.string.save_new_site)
                            },
                            isEnabled = true,
                            modifier = Modifier.weight(1f)
                        )
                        Spacer(modifier = Modifier.width(20f.toScaleDp()))
                        Spacer(modifier = Modifier.weight(0.6f))
                    }
                    Spacer(modifier = Modifier.height(20.toScaleDp()))

                }
            }
        }
    }
}